<template>
  <div class="downAppPage" @contextmenu.prevent>
    <div style="min-width: 984px;max-width: 1490px;margin: auto;">
      <div class="fast-title">{{ $t("homeFirst.Quicktools") }}</div>
      <div class="fast-center">
        <div class="fast-item1">
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin-bottom: 2px;
              gap: 12px;
            "
          >
            <div class="fast-method" @click="$router.push('/files')">
              <img class="icon" :src="$utils.getPng('icon-drive')" alt="" />
              <div class="title">{{ $t("homeFirst.Files") }}</div>
            </div>
            <div class="fast-method" @click="$router.push('/share')">
              <img class="icon" :src="$utils.getPng('icon-share')" alt="" />
              <div class="title">{{ $t("homeFirst.Share") }}</div>
            </div>
            <div class="fast-method" @click="$router.push('/set')">
              <img class="icon" :src="$utils.getPng('icon-set')" alt="" />
              <div class="title">{{ $t("homeFirst.Set") }}</div>
            </div>
            <div class="fast-method" @click="$router.push('/ai')">
              <img class="icon" :src="$utils.getPng('icon-ai')" alt="" />
              <div class="title">{{ $t("homeFirst.DeepSeek") }}</div>
            </div>
            <div class="fast-method" @click="$router.push('/myCollection')">
              <img
                class="icon"
                :src="$utils.getPng('icon-myCollection')"
                alt=""
              />
              <div class="title">{{ $t("homeFirst.Collect") }}</div>
              <el-badge
                class="item12"
                :value="$store.state.collectNum"
                :hidden="$store.state.collectNum == 0"
                :max="99"
              ></el-badge>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; gap: 12px">
            <div
              class="fast-method"
              v-if="this.$store.state.short_url_switch == 1"
              @click="$router.push('/shortChain')"
            >
              <!-- 和占位符互斥关系，短链展示的时候，占位符就要隐藏，占位符展示的时候，短链就要展示，占位符就在下面 -->
              <img
                class="icon"
                :src="$utils.getPng('icon-shortChain')"
                alt=""
              />
              <div class="title">{{ $t("homeFirst.ShortLink") }}</div>
            </div>
            <div class="fast-method" @click="checkFolderFn('云解压')">
              <img
                class="icon"
                :src="$utils.getPng('icon-decompress')"
                alt=""
              />
              <div class="title">{{ $t("homeFirst.Unzip") }}</div>
            </div>
            <div class="fast-method" @click="checkFolderFn('云转存')">
              <img class="icon" :src="$utils.getPng('icon-save')" alt="" />
              <div class="title">{{ $t("homeFirst.Transit") }}</div>
            </div>
            <div class="fast-method" @click="$router.push('/history')">
              <img class="icon" :src="$utils.getPng('icon-history')" alt="" />
              <div class="title">{{ $t("homeFirst.Record") }}</div>
            </div>
            <div class="fast-method" @click="$router.push('/recycle')">
              <img class="icon" :src="$utils.getPng('icon-recycle')" alt="" />
              <div class="title">{{ $t("homeFirst.recycle") }}</div>
            </div>
            <div v-if="this.$store.state.short_url_switch != 1" style="width: 76px; height: 88px">
              <!-- 占位符，和短链互斥关系，短链展示的时候，这个就要隐藏 -->
            </div>
          </div>
        </div>
        <div class="fast-item2">
          <el-carousel
            ref="carousel"
            height="218px"
            indicator-position="none"
            arrow="never"
            @change="handleCarouselChange"
          >
            <el-carousel-item class="acarousel" style="cursor: pointer">
              <div
                class="welfare-card"
                @click="openWelfareInNewTab('/welfare')"
              >
                <div class="welfare-title">{{ $t("homeFirst.welfare") }}</div>
                <div class="progress-container">
                  <div class="circular-progress">
                    <el-progress
                      type="dashboard"
                      :width="104"
                      :stroke-width="8"
                      :percentage="+$store.state?.daily_tasks?.progress_val"
                      color="#F67942"
                      :text-color="
                        $store.state.theme == 'light'
                          ? '#2c2c2c'
                          : 'rgba(255,255,255,0.9)'
                      "
                      :define-back-color="
                        $store.state.theme == 'light'
                          ? '#F6F6F6'
                          : 'rgba(255, 255, 255, 0.12)'
                      "
                    ></el-progress>
                  </div>
                  <div class="task-info">
                    <span class="task-text"
                      >{{ $store.state?.daily_tasks?.name
                      }}{{ $store.state?.daily_tasks?.progress }}</span
                    >
                    <svg-btn class="bell-icon" icon-class="iconliusi"></svg-btn>
                    <!-- <img
                    class="bell-icon"
                    :src="$utils.getPng('web4/icon-fl2')"
                    alt=""
                  /> -->
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item style="cursor: pointer" v-if="$store.state.userInfo.switchs?.referral_program_show_banner == 1">
              <div class="Referralbg-box" @click="oepnExPand">
                <img
                  class="Referralbg"
                  :src="$utils.getPng('web4/Referralbg')"
                />
                <img
                  class="Referralbg2"
                  :src="$utils.getPng('web4/Referralbg2')"
                />
                <div class="text-box">
                  <div class="text1">引荐计划</div>
                  <div class="text2">奖励下载券、会员时长、开通金额</div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item class="acarousel" style="cursor: pointer" v-if="$store.state.userInfo.switchs?.referral_program_show_banner == 1">
              <div
                class="welfare-card"
                @click="openWelfareInNewTab('/welfare')"
              >
                <div class="welfare-title">{{ $t("homeFirst.welfare") }}</div>
                <div class="progress-container">
                  <div class="circular-progress">
                    <el-progress
                      type="dashboard"
                      :width="104"
                      :stroke-width="8"
                      :percentage="+$store.state?.daily_tasks?.progress_val"
                      color="#F67942"
                      :text-color="
                        $store.state.theme == 'light'
                          ? '#2c2c2c'
                          : 'rgba(255,255,255,0.9)'
                      "
                      :define-back-color="
                        $store.state.theme == 'light'
                          ? '#F6F6F6'
                          : 'rgba(255, 255, 255, 0.12)'
                      "
                    ></el-progress>
                  </div>
                  <div class="task-info">
                    <span class="task-text"
                      >{{ $store.state?.daily_tasks?.name
                      }}{{ $store.state?.daily_tasks?.progress }}</span
                    >
                    <svg-btn class="bell-icon" icon-class="iconliusi"></svg-btn>
                    <!-- <img
                    class="bell-icon"
                    :src="$utils.getPng('web4/icon-fl2')"
                    alt=""
                  /> -->
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item style="cursor: pointer" v-if="$store.state.userInfo.switchs?.referral_program_show_banner == 1">
              <div class="Referralbg-box" @click="oepnExPand">
                <img
                  class="Referralbg"
                  :src="$utils.getPng('web4/Referralbg')"
                />
                <img
                  class="Referralbg2"
                  :src="$utils.getPng('web4/Referralbg2')"
                />
                <div class="text-box">
                  <div class="text1">引荐计划</div>
                  <div class="text2">奖励下载券、会员时长、开通金额</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="pagination-dots" v-if="$store.state.userInfo.switchs?.referral_program_show_banner == 1">
            <div
              class="dot"
              :class="{ active: currentCarouselIndex === 0 }"
              @mouseenter="goToSlide(0)"
            ></div>
            <div
              class="dot"
              :class="{ active: currentCarouselIndex === 1 }"
              @mouseenter="goToSlide(1)"
            ></div>
          </div>
        </div>
        <div class="fast-item3" @click="openWelfareInNewTab('/vip')">
          <img class="homevipbg" :src="$utils.getPng('web4/homevipbg')" />
          <div class="title-top">
            <div class="senfen">{{ $store.state?.VipInfo?.header?.title }}</div>
            <div class="time">
              {{ $store.state?.VipInfo?.header?.label
              }}<svg-btn class="le" icon-class="icon_direction_right"></svg-btn>
            </div>
          </div>
          <div class="vip-text">{{ $store.state?.VipInfo?.header?.info }}</div>
          <div class="vip-info">
            <div class="info1">
              <div class="nub">
                <div
                  class="nub1"
                  :style="{
                    fontSize: !isNaN(
                      $store.state?.VipInfo?.consume?.day_down_count
                    )
                      ? '20px'
                      : '16px',
                  }"
                >
                  {{ $store.state?.VipInfo?.consume?.day_down_count }}
                </div>
              </div>
              <div class="bou">{{ $t("homeFirst.DownloadLimit") }}</div>
            </div>
            <div class="info1">
              <div class="nub">
                <div class="nub1">
                  {{ $store.state?.VipInfo?.consume?.point }}
                </div>
              </div>
              <div class="bou">{{ $t("homeFirst.awelfarepoint") }}</div>
            </div>
            <div class="info1">
              <div class="nub">
                <div class="nub2">
                  {{ $store.state?.VipInfo?.consume?.down_speed_text }}
                </div>
              </div>
              <div class="bou">{{ $t("homeFirst.Downloadspeed") }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 动态 -->
      <Dynamic ref="refDynamic" />

      <BindPhone
        :isShow="isShowBindPhone"
        :type="bindType"
        :time="time"
        @getPhoneCode="getPhoneCode"
        @bindPhone="bindPhone"
        @confirmNameAuth="realNameAuth"
        @handleClose="isShowBindPhone = false"
      ></BindPhone>
    </div>
  </div>
</template>

<script>
import {
  bindPhoneAPI,
  bindPhoneSendCode,
  realNameAuth,
} from "@/utils/apiList/account";
import { checkFolder } from "@/utils/apiList/usermsg";
import BindPhone from "@/components/Cloud/BindPhone";
import Dynamic from "./dynamic";
export default {
  components: {
    BindPhone,
    Dynamic,
  },
  data() {
    return {
      currentCarouselIndex: 0, // 当前轮播图索引
      isShowBindPhone: false,
      bindType: 1,
      time: 60,
      msgid: "",
      timerA: null,
      autoPlayTimer: null, // 自动播放定时器
      phone_item: {
        phone: "",
        pcode: "",
        sms_type: 0,
      },
      isLoading: false, // 加载状态
      scrollHandler: null, // 滚动处理函数
    };
  },
  mounted() {
    this.$refs.refDynamic?.webHomeFn();
    this.initScrollListener();
  },
  beforeDestroy() {
    this.removeScrollListener();
  },
  methods: {
    checkFolderFn(folder_name) {
      checkFolder({ folder_name }).then((res) => {
        if (res.status == 1) {
          // 将文件夹信息存储到localStorage，供目标页面使用
          const folderData = {
            folder_id: res.data?.folder_id || 0,
            name: res.data?.name || "全部文件",
            action: "openFolder", // 标识需要执行openFolder操作
          };
          localStorage.setItem("openFolder", JSON.stringify(folderData));

          this.$router.push({ path: "/files" });
        } else {
          this.$toast(res.msg, 2);
        }
      });
    },
    // 轮播图切换事件
    handleCarouselChange(index) {
      // 将4个轮播项的索引映射到2个分页点
      this.currentCarouselIndex = index % 2;
    },
    // 点击分页指示器跳转到指定轮播图
    goToSlide(index) {
      this.$refs.carousel.setActiveItem(index);
    },
    // 在新标签页打开福利社
    openWelfareInNewTab(path) {
      window.open(path, "_blank");
    },
    realNameAuth(data) {
      realNameAuth(data).then((res) => {
        if (res.status == 1) {
          this.isShowBindPhone = false;
          this.$store.commit("getuserVuex");
          this.$toast(res.msg, 1);
        } else {
          this.$toast(res.msg, 2);
        }
      });
    },
    oepnExPand() {
      if (this.checkPhoneEmpty()) {
        this.bindType = 1;
        this.isShowBindPhone = true;
        return;
      }
      const url = process.env.VUE_APP_DAREN_URL + "/referralProgram";
      window.open(url, "_blank");
    },
    bindPhone(data) {
      let params = { msgid: this.msgid, ...data };
      bindPhoneAPI(params).then((res) => {
        if (res.status == "1") {
          this.isShowBindPhone = false;
          this.$store.commit("getuserVuex");
          this.$toast(res.msg, 1);

          if (this.$store.state.bindPhoneCallback) {
            this.$store.state.bindPhoneCallback();
          }
          setTimeout(() => {
            const url = process.env.VUE_APP_DAREN_URL + "/referralProgram";
            window.open(url, "_blank");
          }, 300);
        } else {
          this.$toast(res.msg, 2);
        }
      });
    },
    //判断手机号是否为空
    checkPhoneEmpty() {
      // 从 store 中获取 userInfo 对象
      const userInfo = this.$store.state.userInfo;
      // 检查 phone 属性是否为空字符串
      if (userInfo && userInfo.phone == "") {
        return true;
      }
      return false;
    },
    getPhoneCode(phone, pcode, sms_type) {
      this.phone_item = {
        phone,
        pcode,
        sms_type,
      };
      this.getPhoneAly();
    },
    getPhoneAly(captcha_verify, validate = {}) {
      return new Promise((resolve) => {
        if (validate == "close") {
          return;
        }
        bindPhoneSendCode({
          phone: this.phone_item.phone,
          pcode: this.phone_item.pcode,
          sms_type: this.phone_item.sms_type,
          captcha_verify: captcha_verify || "",
          lot_number: validate?.lot_number || "",
          captcha_output: validate?.captcha_output || "",
          pass_token: validate?.pass_token || "",
          gen_time: validate?.gen_time || "",
        }).then((res) => {
          if (res.status == "1") {
            resolve({
              result: true,
              validate: true,
            });
            this.$toast(res.msg, 1);
            this.msgid = res.data.msgid;
            this.bindType = 3;
            this.timerA = setInterval(() => {
              this.minute();
              this.$refs.bindPhoneCom?.onFocus();
            }, 1000);
          } else if (res.status == 90001) {
            resolve({
              result: false,
              validate: false,
            });
            this.$toast(res.msg, 2);
            this.$AliCode.handleOpen(this.getPhoneAly);
          } else if (res.status == 90002) {
            this.$utils.initgt4(
              "5b0562a75492b420626b745b229e83a4",
              this.getPhoneAly
            );
          } else {
            resolve({
              result: true,
              validate: true,
            });
            this.$toast(res.msg, 2);
          }
        });
      });
    },
    minute() {
      this.time = this.time - 1;
      if (this.time == 0) {
        this.time = 60;
        clearInterval(this.timerA);
      }
    },
    // 初始化滚动监听器
    initScrollListener() {
      // 使用 Intersection Observer API 来检测触底
      this.initIntersectionObserver();

      // 同时保留 window 滚动监听作为备用
      this.scrollHandler = () => {
        this.handleScroll();
      };
      window.addEventListener("scroll", this.scrollHandler);
    },

    // 使用 Intersection Observer 检测触底
    initIntersectionObserver() {
      // 创建一个观察器
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.loadMoreData();
            }
          });
        },
        {
          root: null, // 使用视口作为根
          rootMargin: "100px", // 提前100px触发
          threshold: 0.1,
        }
      );

      // 等待动态组件渲染完成后添加观察目标
      this.$nextTick(() => {
        this.addObserverTarget();
      });
    },

    // 添加观察目标
    addObserverTarget() {
      // 查找动态列表容器
      const dynamicContainer = document.querySelector(".dynamic-box");
      if (dynamicContainer) {
        // 创建一个触底检测元素
        this.triggerElement = document.createElement("div");
        this.triggerElement.style.height = "1px";
        this.triggerElement.style.width = "100%";
        this.triggerElement.style.background = "transparent";
        dynamicContainer.appendChild(this.triggerElement);

        // 开始观察
        this.observer.observe(this.triggerElement);
      } else {
        setTimeout(() => this.addObserverTarget(), 500);
      }
    },
    // 移除滚动监听器
    removeScrollListener() {
      if (this.scrollHandler) {
        window.removeEventListener("scroll", this.scrollHandler);
        this.scrollHandler = null;
      }

      // 清理 Intersection Observer
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      // 清理触底检测元素
      if (this.triggerElement && this.triggerElement.parentNode) {
        this.triggerElement.parentNode.removeChild(this.triggerElement);
        this.triggerElement = null;
      }
    },
    // 节流函数
    throttle(func, delay) {
      let timeoutId;
      let lastExecTime = 0;
      return function (...args) {
        const currentTime = Date.now();
        if (currentTime - lastExecTime > delay) {
          func.apply(this, args);
          lastExecTime = currentTime;
        } else {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            func.apply(this, args);
            lastExecTime = Date.now();
          }, delay - (currentTime - lastExecTime));
        }
      };
    },
    // 处理滚动事件
    handleScroll() {
      // 检查是否滚动到底部
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // 调试信息（只在接近底部时打印，避免过多日志）
      if (scrollTop + windowHeight >= documentHeight - 200) {
        // console.log('滚动检测:', {
        //   scrollTop,
        //   windowHeight,
        //   documentHeight,
        //   isNearBottom: scrollTop + windowHeight >= documentHeight - 100,
        //   messageDetails: this.$refs.refDynamic?.messageDetails,
        //   distanceFromBottom: documentHeight - (scrollTop + windowHeight)
        // });
      }

      // 当滚动到距离底部100px以内时触发加载
      if (scrollTop + windowHeight >= documentHeight - 100) {
        this.loadMoreData();
      }
    },
    // 加载更多数据
    loadMoreData() {
      // 防止重复加载
      if (this.isLoading) {
        return;
      }

      // 检查refDynamic组件是否存在
      if (this.$refs.refDynamic) {
        // 如果处于详情页面状态，调用getDynamicDetailsFn
        if (this.$refs.refDynamic.messageDetails) {
          this.isLoading = true;

          // 调用refDynamic组件的getDynamicDetailsFn方法
          this.$refs.refDynamic.getDynamicDetailsFn().finally(() => {
            this.isLoading = false;
          });
        } else {
          // console.log('当前在动态列表页面，触底加载不适用');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
